import './index.scss';
import TrialFormController from './form';
import TrialOffersController from './offers';
import TrialSuccessController from './success';
import { Application, Controller } from 'utils/stimulus';

export default class TrialModalController extends Controller {
  static targets = ['modal', 'screenOffers', 'screenForm', 'screenSuccess'];

  initialize() {
    const key = this.modalTarget.getAttribute('data-gateway-public-key');

    if (!key) {
      return;
    }

    vendorManager.ensure(
      'mercadopago',
      () => {
        window.Mercadopago.setPublishableKey(key);
      },
      'https://secure.mlstatic.com/sdk/javascript/v1/mercadopago.js'
    );
  }

  connect() {
    this.on('selectOffer', this.goToForm.bind(this));
    this.on('goToSuccess', this.goToSuccess.bind(this));

    this.eventData = {
      place: '',
      time: this.modalTarget.getAttribute('data-time'),
      page: this.getPageEventValue()
    };

    this.createEntryButtons();
    window.openTrialModal = (origin, offerId) =>
      this.openModal(origin, offerId);
  }

  getPageEventValue() {
    const url = window.location.href;

    if (url.includes('questoes/')) {
      return 'questoes show';
    }

    if (url.includes('questoes')) {
      return 'questoes';
    }

    return 'outras páginas';
  }

  openModal(origin, offerId) {
    this.eventData.place = origin;

    this.modalTarget.style.display = 'block';
    setTimeout(() => {
      this.modalTarget.classList.add('q-trial-modal--open');
    }, 10);

    document.querySelector('body').classList.add('q-no-scroll');

    this.trackEvent('trial clicked');
    this.trigger('trial-offers->setInitialOffer', offerId);
  }

  closeModal() {
    this.modalTarget.classList.remove('q-trial-modal--open');
    setTimeout(() => {
      this.modalTarget.style.display = 'none';
      this.goToOffers();
    }, 300);

    document.querySelector('body').classList.remove('q-no-scroll');

    const isSuccessScreenActive = this.screenSuccessTarget.classList.contains(
      'q-trial-modal__screen--active'
    );

    if (isSuccessScreenActive) {
      window.location.reload();
    }
  }

  hideCurrentScreen() {
    this.element
      .querySelector('.q-trial-modal__screen--active')
      .classList.remove('q-trial-modal__screen--active');
  }

  trackEvent(name) {
    UserTracker.emit('event', {
      eventName: name,
      data: this.eventData
    });
  }

  goToOffers() {
    this.hideCurrentScreen();

    this.screenOffersTarget.classList.add('q-trial-modal__screen--active');
  }

  goToForm(offerData) {
    this.trigger('trial-form->updateOffer', offerData);
    this.trigger('trial-success->updateOffer', offerData);

    this.eventData['offer id'] = offerData.offerId;
    this.eventData['offer name'] = offerData.offerName;
    this.trackEvent('trial checkout started');

    this.hideCurrentScreen();
    this.screenFormTarget.classList.add('q-trial-modal__screen--active');
  }

  goToSuccess() {
    this.hideCurrentScreen();
    this.trackEvent('trial checkout completed');

    this.screenSuccessTarget.classList.add('q-trial-modal__screen--active');
  }

  createEntryButtons() {
    const { showButtonOnHeader, showFloatingButtonOnQuestionPage } =
      window.gon.flags.trial_settings;

    if (showButtonOnHeader) {
      const days = this.modalTarget.getAttribute('data-time');
      const $desktopHeader = document.querySelector('.q-desktop-right-nav');
      const $mobileMenu = document.querySelector('.q-segments-mobile-menu-cta');

      let $desktopButton = document.createElement('div');
      $desktopButton.innerHTML = `
            <button class="q-trial-navbar-button q-trial-navbar-button--desktop">
              Teste com ${days} dias gratuitos
            </button>
          `.trim();
      $desktopButton = $desktopButton.firstChild;

      let $mobileButton = document.createElement('div');
      $mobileButton.innerHTML = `
            <button class="q-trial-navbar-button q-trial-navbar-button--mobile">
              Teste ${days} dias grátis
            </button>
          `.trim();
      $mobileButton = $mobileButton.firstChild;

      $desktopHeader.insertBefore($desktopButton, $desktopHeader.firstChild);
      $mobileMenu.insertBefore($mobileButton, $mobileMenu.firstChild);

      $desktopButton.addEventListener('click', () =>
        this.openModal('navbar button')
      );
      $mobileButton.addEventListener('click', () =>
        this.openModal('navbar button')
      );
    }

    if (
      showFloatingButtonOnQuestionPage &&
      window.location.href.includes('/questoes')
    ) {
      let $floatingButton = document.createElement('div');
      $floatingButton.innerHTML = `
                <button class="q-trial-floating-button q-trial-floating-button--show">
                  <span class="text-mobile">Experimente grátis</span>
                  <span class="text-desktop">Experimente gratuitamente</span>
                  <i class="q-icon q-icon-times close-button"></i>
                </button>
              `.trim();
      $floatingButton = $floatingButton.firstChild;

      document.querySelector('body').appendChild($floatingButton);

      $floatingButton.addEventListener('click', event => {
        if (event.target.classList.contains('close-button')) {
          $floatingButton.remove();
          return;
        }
        this.openModal('floating button');
      });
    }
  }
}

if (!window.TrialApplication) {
  window.TrialApplication = Application.start();
  window.TrialApplication.register('trial-modal', TrialModalController);
  window.TrialApplication.register('trial-offers', TrialOffersController);
  window.TrialApplication.register('trial-form', TrialFormController);
  window.TrialApplication.register('trial-success', TrialSuccessController);
}
